var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPersonEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 22.5H21V21C21 20.5861 20.6639 20.25 20.25 20.25H15.75C15.3362 20.25 15 20.5861 15 21V22.5H13.5V21C13.5 19.7593 14.5093 18.75 15.75 18.75H20.25C21.4907 18.75 22.5 19.7593 22.5 21V22.5ZM11.25 19.5H3C2.17275 19.5 1.5 18.8269 1.5 18V6C1.5 5.17275 2.17275 4.5 3 4.5H21C21.8269 4.5 22.5 5.17275 22.5 6V9.75H21V6.68115L12.427 12.6167C12.1699 12.7947 11.8301 12.7947 11.573 12.6167L2.99993 6.68115V18H11.2499L11.25 19.5ZM4.65128 6L12 11.0878L19.3491 6H4.65128ZM18 18C16.3454 18 15 16.6546 15 15C15 13.3454 16.3454 12 18 12C19.6546 12 21 13.3454 21 15C21 16.6546 19.6546 18 18 18ZM18 13.5C17.1731 13.5 16.5 14.1731 16.5 15C16.5 15.8269 17.1731 16.5 18 16.5C18.8269 16.5 19.5 15.8269 19.5 15C19.5 14.1731 18.8269 13.5 18 13.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPersonEmail);
export default __webpack_public_path__ + "static/media/ic-person-email.93c7954f57512779a1d83c1662aecf10.svg";
export { ForwardRef as ReactComponent };